/**
 * Get the value of a cookie.
 * @category Core
 *
 * @param name The name of the cookie
 */
export function getCookie(name) {
    if (typeof document === 'undefined' || !document.cookie)
        return null;
    const v = document.cookie.match(`(^|;) ?${name}=([^;]*)(;|$)`);
    return v ? v[2] : null;
}
//# sourceMappingURL=getCookie.js.map